import React, { useCallback, useState, useEffect } from 'react';

import {
  FormControl,
  FormLabel,
  FormErrorMessage,
  Checkbox,
  Box,
  Flex
} from '@chakra-ui/react';

const CheckboxComponent = ({
  dataId = null,
  fieldId,
  submitAttempted,
  defaultPlaceholder,
  fieldLabel,
  fieldValue,
  required,
  errorMessage,
  onChange = (value) => {},
  onReady = () => {}
}) => {
  const [isError, setIsError] = useState(required);

  const handleOnChange = useCallback(
    (value) => {
      const isInvalid = required === true && value !== true;
      setIsError(isInvalid);

      onChange({
        fieldId,
        value,
        label: fieldLabel,
        isValid: isInvalid === false
      });
    },
    [onChange, fieldId, fieldLabel, required]
  );

  useEffect(() => {
    onReady({
      fieldId,
      required
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const appendAsterisk = (html) => {
    // Insert an asterisk at the end of the HTML string
    return `${html} <span style="color: #E53E3E;">*</span>`;
  };

  return (
    <FormControl
      mb="3"
      isInvalid={submitAttempted && isError}
      isRequired={required}>
      {typeof fieldLabel === `string` && fieldLabel.length > 0 && (
        <FormLabel
          id={`field-label-text-${fieldId}-${fieldLabel}`}
          htmlFor={fieldId}
          mb="2">
          {fieldLabel}
        </FormLabel>
      )}
      <Flex alignItems="flex-start" gap="2">
        <Checkbox
          dataid={dataId}
          id={fieldId}
          name={fieldLabel}
          value={fieldValue}
          borderRadius="xs"
          background="white"
          borderColor="primary.dark-blue"
          mt="0.3125rem"
          onChange={(event) => handleOnChange(event.target.checked)}
          onBlur={(event) => handleOnChange(event.target.checked)}
        />
        <Box
          as="span"
          // Need to use dangerouslySetInnerHTML to ensure correct formatting.
          dangerouslySetInnerHTML={{
            __html: required ? appendAsterisk(fieldValue) : fieldValue
          }}
          sx={{
            a: {
              textDecoration: `underline`
            }
          }}
        />
      </Flex>
      {submitAttempted && isError && (
        <FormErrorMessage>{errorMessage}</FormErrorMessage>
      )}
    </FormControl>
  );
};

export default CheckboxComponent;
